<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Unidades</li>
        </ol>

        <v-card>
          <v-card-title>
            <h3>Unidades</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table rows-per-page-text="Linhas por Página" :no-data-text="textoTabela" :headers="headers" :items="unidades" :search="search" :pagination.sync="pagination" class="less-space">
            <template slot="items" slot-scope="props">
              <td>{{ padronizaData(props.item.created_at)}}</td>
              <td>{{ props.item.nome_unidade }}</td>
              <td>{{ props.item.CEP }}</td>
              <td class="text-xs-right many-buttons">
                <span v-if="!(props.item.deleted_at)">
                  <router-link
                    class="btn mr-2 text-white blue-grey darken-4"
                    :to="'unidades/'+props.item.id"
                  >
                    <i class="fa fa-eye"></i> Detalhes
                  </router-link>
                </span>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta, confirmaSoft } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      pagination: {
        rowsPerPage: 5
      },
      headers: [
        { text: "Data de criação", value: "created_at" },
        { text: "Nome da Unidade", value: "nome_unidade" },
        { text: "CEP", value: "CEP"},
        { text: "", value: ""}
      ],
      unidades: [],
      isLoading: false
    };
  },
  mounted() {
    var self = this;

    self.isLoading = true;
    ajax("get", "unidades")
      .then(res => {
        self.isLoading = false;
        self.unidades = res;
      })
      
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error);
      });
  },
  methods: {
    async desativaUnidade(unidade){
      if(await confirmaSoft()) {
        let self = this;
        self.isLoading = true;
        ajax("delete", "unidades/" + unidade.id)
          .then(() => {
            let indexItemRemovido = self.unidades.findIndex(
              x => x.id == unidade.id
            );
            self.unidades[indexItemRemovido].deleted_at = 1;
            self.isLoading = false;
            alerta(
              "success",
              "Desativado",
              "Unidade desativada com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      }
    },
    ativaUnidade(unidade){
      let self = this;
      self.isLoading = true;
      ajax("put", "unidades/" + unidade.id, {deleted_at: null})
      .then(() => {
        self.isLoading = false;
        let indexItemRemovido = self.unidades.findIndex(
            x => x.id == unidade.id
        );
        self.unidades[indexItemRemovido].deleted_at = null;
        alerta(
          "success",
          "Ativada",
          "Unidade ativada com sucesso!"
        );
      })
      .catch(err => {
        self.isLoading = false;
        tratamento_requisicao(err);
      })
    }
  }
};
</script>